import { inject, Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { UrlsEnum } from '@lentau/ui-kit/core/enums/route.enum';

@Injectable({ providedIn: 'root' })
export class HappyCloseGuardService {
  private router: Router = inject(Router);
  public canActivate(): boolean {
    this.router.navigate([UrlsEnum.LoyaltyProfile], { queryParams: { happyClose: true } });
    return true;
  }
}
